import React, { useEffect, useState } from "react";
import { FaBars, FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

import logo from "../../assets/imagens/logo+white.png";

import "./styles.css";

const Sidebar = (props) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Função para obter o estado inicial do collapse
  const getInitialCollapseState = () => {
    // Se defaultCollapsed for true, força o collapse
    if (props.defaultCollapsed === true) {
      return true;
    }

    // Caso contrário, verifica o localStorage
    const savedState = localStorage.getItem("sidebar_collapsed");
    return savedState === "true";
  };

  const [isCollapsed, setIsCollapsed] = useState(getInitialCollapseState());

  const handleQuotesClick = (e) => {
    e.preventDefault();
    localStorage.removeItem("quotes_engineering_state");
    navigate("/quotes-enginner");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect para salvar o estado no localStorage sempre que mudar
  useEffect(() => {
    localStorage.setItem("sidebar_collapsed", isCollapsed.toString());
  }, [isCollapsed]);

  // useEffect para forçar collapse se defaultCollapsed for true
  useEffect(() => {
    if (props.defaultCollapsed === true) {
      setIsCollapsed(true);
      localStorage.setItem("sidebar_collapsed", "true");
    }
  }, [props.defaultCollapsed]);

  const active = {
    armadors: "",
    dashboard: "",
    admin: "",
    cadastros: "",
    cotacoes: "",
    cotacoes_nac: "",
    bookings: "",
    tracking: "",
    pagamentos: "",
    demandas: "",
    uploadContratos: "",
    negociacoes: "",
    impulsionar: "",
    upload: "",
    conta: "",
    quotesenginner: "",
    schedule: "",
    mareia: "",
  };

  const email = localStorage.getItem("user_email");
  active[props.elementoAtivo] = "active";

  const toggleCollapse = () => {
    const newCollapseState = !isCollapsed;
    setIsCollapsed(newCollapseState);
    // O localStorage será atualizado automaticamente pelo useEffect
  };

  const handleMenuItemClick = () => {
    if (isMobile) {
      setMenuOpen(false);
    }
  };

  return (
    <>
      {isMobile && (
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}

      <div className={`sidebar ${menuOpen ? "open" : ""} ${isMobile ? "mobile" : ""} ${isCollapsed ? "collapsed" : ""}`}>
        {!isMobile && (
          <div className="collapse-toggle" onClick={toggleCollapse}>
            {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </div>
        )}

        <div className="sidebar-title">
          <img src={logo} alt="Logo Zarpar" />

          <div className="logo-collapsed">Z</div>
        </div>

        <div className="menu">
          <ul>
            {(email === "email@email.com" || email === "alvaro@karavel.com.br") && (
              <li className={active.admin} data-tooltip="Painel de Controle">
                <img
                  src="/imagens/menu/gear.svg"
                  style={{ width: "25px", height: "25px" }}
                  alt=""
                />
                <Link to="/admin" onClick={handleMenuItemClick}>
                  <span className="menu-text"><strong>Painel de Controle</strong></span>
                </Link>
              </li>
            )}

            {(email === "ffleck@gmail.com" || email === "alvaro@karavel.com.br") && (
              <li className={active.cadastros} data-tooltip="Cadastros">
                <img
                  src="/imagens/menu/impulsionar.svg"
                  style={{ width: "25px", height: "25px" }}
                  alt=""
                />
                <Link to="/cadastros" onClick={handleMenuItemClick}>
                  <span className="menu-text"><strong>Cadastros</strong></span>
                </Link>
              </li>
            )}

            <li className={active.dashboard} data-tooltip="Dashboard">
              <img
                src="/imagens/menu/home.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/dashboard" onClick={handleMenuItemClick}>
                <span className="menu-text">Dashboard</span>
              </Link>
            </li>

            <li className={active.quotesenginner} data-tooltip="Cotação - SPOT">
              <img
                src="/imagens/menu/cotacao.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <a href="/quotes-enginner" onClick={(e) => {
                handleQuotesClick(e);
                handleMenuItemClick();
              }}>
                <span className="menu-text">Cotação - SPOT</span>
              </a>
            </li>

            <li className={active.cotacoes_nac} data-tooltip="Cotação - NAC">
              <img
                src="/imagens/menu/cotacoes_nac.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/nac" onClick={handleMenuItemClick}>
                <span className="menu-text">Cotação - NAC</span>
              </Link>
            </li>

            <li className={active.bookings} data-tooltip="Bookings">
              <img
                src="/imagens/menu/booking.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/bookings" onClick={handleMenuItemClick}>
                <span className="menu-text">Bookings</span>
              </Link>
            </li>

            <li className={active.schedule} data-tooltip="Schedules">
              <img
                src="/imagens/menu/schedule.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/schedule" onClick={handleMenuItemClick}>
                <span className="menu-text">
                  Schedules
                  <span className="badge">Beta</span>
                </span>
              </Link>
            </li>

            <li className={active.mareia} data-tooltip="Mare IA">
              <img
                src="/imagens/menu/mare.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/mare" onClick={handleMenuItemClick}>
                <span className="menu-text">
                  Mare IA
                  <span className="badge">Em Breve</span>
                </span>
              </Link>
            </li>

            <li className={active.armadors} data-tooltip="Armadores">
              <img
                src="/imagens/menu/tracking.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/armadores" onClick={handleMenuItemClick}>
                <span className="menu-text">Armadores</span>
              </Link>
            </li>

            <li className={active.uploadContratos} data-tooltip="Upload de Contratos">
              <img
                src="/imagens/menu/upload.svg"  
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/upload-contratos" onClick={handleMenuItemClick}>
                <span className="menu-text">Upload de Contratos</span>
              </Link>
            </li>

            {(email === "ffleck@gmail.com" || email === "alvaro@karavel.com.br") && (
              <li className={active.upload} data-tooltip="Upload">
                <i className="fa-solid fa-upload"></i>
                <Link to="/upload" onClick={handleMenuItemClick}>
                  <span className="menu-text">Upload</span>
                </Link>
              </li>
            )}

            <li className={active.conta} data-tooltip="Minha Conta">
              <img
                src="/imagens/menu/conta.svg"
                style={{ width: "25px", height: "25px" }}
                alt=""
              />
              <Link to="/conta" onClick={handleMenuItemClick}>
                <span className="menu-text">Minha Conta</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
